import { Toast } from '@shopify/polaris';
import { useContext } from 'react';
import ToastContext from '../context/ToastContext';
import { RESET_ALERT } from '../context/ToastReducer';

const AlertToast = () => {
  const [stateToast, dispatchToast] = useContext(ToastContext);

  return (
    <>
      {stateToast && (
        <Toast
          content={stateToast.message}
          error={stateToast.error ?? false}
          duration={5000}
          onDismiss={() => {
            dispatchToast({ type: RESET_ALERT });
          }}
        />
      )}
    </>
  );
};

export default AlertToast;
